export default "//file.bilionpass.com/japandx-portal/0.1.21/static/img/combination-select-arrow.b538bef5-9110d1.svg";